<template>
  <div class="w-full h-full overflow-y-auto">
    <el-form class="w-800px m-auto my-0" :model="form" :rules="formRule" ref="formRef">
      <el-form-item label="英文名称" prop="engName">
        <el-input v-model="form.engName" :disabled="form.id > -1||modelNameDisable" placeholder="Name model name" maxlength="100"
          show-word-limit />
          <el-popover
            placement="right"
            title="提示"
            width="340"
            trigger="hover"
            style="position: absolute; right: -25px;"
          >
            <div>
              创建保存之后，若需修改，请到<br />
              用户中心-我的资源-代码”里进行修改
            </div>
            <img
              src="@/assets/images/information.png"
              class="w-19px h-19px ml-10px"
              slot="reference"
            />
          </el-popover>
        <!-- <div class="tips">
          <img src="@/assets/images/information.png" class="w-19px h-19px" />
          <span class="ml-10px text-default text-16px">一经创建不可修改</span>
        </div> -->
      </el-form-item>
      <el-form-item label="中文名称" prop="name">
        <el-input v-model="form.name" placeholder="为您的代码起个名字，最多100字" maxlength="100" show-word-limit />
      </el-form-item>
      <el-form-item label="代码类型" prop="modelType">
        <select-model-type v-model="form.modelType" :props="{ expandTrigger: 'hover' }"></select-model-type>
      </el-form-item>
      <el-form-item label="发布者" prop="owner">
        <el-select v-model="form.owner" :disabled="form.id > -1">
          <el-option v-for="(item, index) in ownerOptions" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <div class="tips">
          <img src="@/assets/images/information.png" class="w-19px h-19px" />
          <span class="ml-10px text-default text-16px">一经创建不可修改</span>
        </div>
      </el-form-item>
      <el-form-item label="开源协议" prop="protocol">
        <el-select v-model="form.protocol" placeholder="请选择开源协议">
          <el-option v-for="item in protocolOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否公开" prop="isOpen">
        <el-radio v-model="form.isOpen" v-for="item in $store.state.selectOptions.isOpen" :key="item.id"
          :label="item.id">{{ item.name }}</el-radio>
      </el-form-item>
      <el-form-item label="项目简介">
        <el-input v-model="form.modelProfile" type="textarea" placeholder="请填写简介，最多500字" :rows="3" maxlength="500"
          show-word-limit></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getPublisher } from '@/utils/getSelectOptions'
import { valiEngName } from '@/utils/validate'
import selectModelType from '@/components/select-model-type.vue'

export default {
  components: { selectModelType },
  model: {
    prop: 'form',
    event: 'setForm'
  },
  props: ['form'],
  data() {
    const engNameValidate = (rule, value, callback) => {
      const { status, message } = valiEngName(value)

      if (!status) {
        callback(message)
      } else {
        callback()
      }
    }

    return {
      formRule: {
        engName: [
          { required: true, validator: engNameValidate, trigger: 'blur' }
        ],
        name: [{ required: true, message: '请填写中文名称', trigger: 'blur' }],
        modelType: [
          { required: true, message: '请选择代码类型', trigger: 'change' }
        ],
        owner: [{ required: true, message: '请选择发布者', trigger: 'change' }],
        protocol: [
          { required: true, message: '请选择开源协议', trigger: 'change' }
        ],
        isOpen: [
          { required: true, message: '请选择是否公开', trigger: 'change' }
        ]
      },
      modelNameDisable:false
    }
  },
  computed: {
    protocolOptions() {
      return this.$store.state.selectOptions.license
    },
    ownerOptions() {
      return this.$store.state.selectOptions.owner
    }
  },
  created() {
    getPublisher()
  },
  mounted() { },
  methods: {
    setDisable(){
      this.modelNameDisable=true
    },
    setUnDisable(){
      this.modelNameDisable=false
    }
  }
}
</script>
<style lang="scss" scoped>

.tips {
  right: -170px;
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
  display: flex;
  align-items: center;
}

</style>
